import { verticalFadeIn } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { contentStyles, paragraphRegular, paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled(m.a).attrs((props) => ({
    initial: 'hidden',
    animate: props['data-visible'] ? 'visible' : 'hidden',
    transition: {
        staggerChildren: 0.1,
    },
})) `
  border-radius: 24px;
  width: 100%;
  --height: ${fluid(416, 512)};
  max-height: var(--height);
  min-height: var(--height);
  height: 100%;
  position: relative;
  display: flex;
  padding: ${fluid(16, 24)};
  text-decoration: none;
  overflow: hidden;
`;
const Layout = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 1;
`;
const TagsWrapper = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(15),
})) ``;
const BackgroundImage = styled(m.div) `
  position: absolute;
  z-index: 0;
  inset: 0;
  width: 100%;
  height: 100%;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
  }
`;
const Content = styled(m.div).attrs(() => ({
    variants: {
        visible: {
            transition: {
                staggerChildren: 0.1,
            },
        },
    },
})) `
  display: flex;
  flex-direction: column;
  color: ${brand.primary.white};
`;
const DateEstimatedReadingTime = styled(m.span).attrs(() => ({
    variants: verticalFadeIn(15),
})) `
  @media ${until(Device.TabletLarge)} {
    margin-bottom: 12px;
    ${fonts.poppins.extraBold}
  }
  @media ${from(Device.TabletLarge)} {
    margin-bottom: 8px;
    ${fonts.poppins.regular}
  }
  font-size: ${fluid(13, 16)};
  line-height: ${fluid(14, 23)};
`;
const Title = styled(m.span).attrs(() => ({
    variants: verticalFadeIn(15),
})) `
  ${paragraphRegular};
  ${fonts.poppins.extraBold};
  margin-bottom: 16px;
  line-height: ${fluid(24, 32)};
`;
const Intro = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(15),
})) `
  ${contentStyles};

  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 24px;

  p,
  li {
    ${paragraphSmall};
  }

  ul:not([style*='list-style-type']) li::before {
    top: ${fluid(5, 7.5)};
  }

  ol,
  ul {
    margin-top: ${fluid(14, 20)};
    margin-bottom: ${fluid(14, 20)};
  }

  @media ${from(Device.TabletLarge)} {
    -webkit-line-clamp: 2;
    margin-bottom: 16px;
  }
`;
const ReadMore = styled(m.div).attrs(() => ({
    variants: verticalFadeIn(15),
})) `
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;

  ${ButtonStyles.Container} {
    --borderRadius: 4px;
    --borderWidth: 2px;
    --buttonHeight: ${fluid(32, 40)};
  }

  span {
    ${fonts.poppins.bold};
    font-size: 16px;
    line-height: 19px;
  }
`;
export const BlogCardStyles = {
    Container,
    BackgroundImage,
    Layout,
    Content,
    DateEstimatedReadingTime,
    Title,
    Intro,
    ReadMore,
    TagsWrapper,
};
